import { IonButton } from '@ionic/react';
import { useState } from 'react';
import { formatDate } from '../i18n/format';
import { useMessages } from '../i18n/LanguageProvider';
import { useAppData } from '../state/AppDataProvider';
import { useCalendarChange } from './use-calendar-change';

/**
 * DE: Eigene Ruhetage: an diesen Tagen gibt es keinen Einkauf.
 * EN: Own closed days: no shopping trip on these days.
 */
export function ClosedDaysSection() {
  const { data } = useAppData();
  const { language, t } = useMessages();
  const changeCalendar = useCalendarChange();
  const [draft, setDraft] = useState('');
  const add = () => {
    if (!draft) return;
    changeCalendar({ type: 'add-closed-date', date: draft });
    setDraft('');
  };
  const dates = data.household.closedDates;
  return (
    <section className="app-card">
      <h2>{t.closedDaysTitle}</h2>
      <p className="app-muted">{t.closedDaysHint}</p>
      <div className="app-actions app-field">
        <input
          type="date"
          className="app-input"
          aria-label={t.closedDaysTitle}
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
        />
        <IonButton onClick={add}>{t.addClosedDay}</IonButton>
      </div>
      {dates.length === 0 ? (
        <p className="app-muted">{t.noClosedDays}</p>
      ) : (
        <ul className="app-rows">
          {dates.map((date) => (
            <li key={date} className="app-row">
              <span>{formatDate(date, language, 'weekday-long')}</span>
              <button
                type="button"
                className="app-link app-row-value"
                onClick={() => changeCalendar({ type: 'remove-closed-date', date })}
              >
                {t.remove}
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
